import clsx from 'clsx';
import {  useContext, useEffect, useMemo, useState} from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { MediaDesktop, MediaMobile, MediaTablet } from '../../../api/const/MediaQuery';
import useMediaQuery from '../../../hook/useMediaQuery';
import jsonVoice from '../../../jsonMock/mockHeaderMenu.json';
import { AppGeneralContext } from '../../../shared/GeneralContext/GeneralContext';
import './AnchorMenu.css'
import { LoginType } from 'components/types/Context';

export const AnchorMenu = () => {
    const desktop = useMediaQuery(MediaDesktop)
    const tablet = useMediaQuery(MediaTablet)
    const mobile = useMediaQuery(MediaMobile)
    const { setMenuIsOpen,user,loginType } = useContext(AppGeneralContext)
    const location = useLocation()
    const [menuHorizontal ,setMenuHorizontal] =  useState<boolean>(false)
    const navigate = useNavigate();
    const [home, setHome] = useState<string>("")

    useEffect(() => {
      if (user?.email) {
        let route = loginType === LoginType.startup ? "start-up" : "corporate"
        setHome(`${route}/profile`)
      } else {
        setHome("/login")
      }
    }, [user?.email, loginType])

    const showHomeLink = useMemo(()=>{
        if (
        location.pathname.toLowerCase().includes('/login') ||
        location.pathname.toLowerCase().includes('/getstarted')) {
            return null
        }
        return (
                <li className='mt-2 mb-2'  onClick={()=>{if(!menuHorizontal)setMenuIsOpen(false)}}>
                 <Link to={home}>HOME</Link>
            </li>
            )
    
    },[location,home,user])

    const showLogin = useMemo(()=>{
        if (location.pathname === '/' ||
        location.pathname.toLowerCase().includes('/login') ||
        location.pathname.toLowerCase().includes('/getstarted')) {

      
            return (
                <>
                   <li className={!menuHorizontal ? "mt-2 mb-2" : ""}><a className="anchor_menu " rel="noreferrer" href=""  onClick={() => navigate("/login")}>LOGIN</a></li>  
                    
                </>
            )
        }
        return null
    
    },[location])
   
 useEffect(()=>{
  
    if(location.pathname === '/' ||
    location.pathname.toLowerCase().includes('/login') ||
    location.pathname.toLowerCase().includes('/getstarted')){
            if(mobile || tablet || desktop){
                setMenuHorizontal(false)
            }else{
                setMenuHorizontal(true)
            }
        }else{
                setMenuHorizontal(false)
        }

  },[desktop, mobile, tablet , location.pathname])


    return (
        <ul className={clsx("d-flex list-reset me-2", {
            "  justify-content-end w-70 align-items-center flex-row me-5 ": menuHorizontal,
            "flex-column   align-items-start justify-content-start  mt-4 mb-4" : !menuHorizontal
        })}>
          {showHomeLink}
          
            {jsonVoice.map((el, index) =>
                <li key={index} className={!menuHorizontal ? "mt-2 mb-2 " : " me-5 ms-3"}>
                    <a href={el.route}
                        rel="noreferrer"
                        target="_blank"
                        className="anchor_menu"
                        onClick={()=>{if(!menuHorizontal)setMenuIsOpen(false)}}>
                        {el.title}
                    </a>
                </li>
            )}
           {showLogin}
        </ul>
    )
}